export default function FinalCta() {
  const jump = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-primary-600 px-6 py-10 md:px-12 md:py-14">
          <div
            className="pointer-events-none absolute -right-16 -top-16 w-64 h-64 rounded-full bg-accent-500/25 blur-3xl"
            aria-hidden="true"
          />
          <div
            className="pointer-events-none absolute -left-20 -bottom-20 w-64 h-64 rounded-full bg-foreground-950/25 blur-3xl"
            aria-hidden="true"
          />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
            <div className="lg:col-span-8">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 leading-snug">
                找到入口只是第一步，用对方法才能每次都顺利
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-primary-100 max-w-2xl">
                把本页当作一份可反复查阅的访问手册：需要时对照访问流程，遇到异常时查阅问题速查，拿不准时回顾识别真伪的要点。地址会变，方法不变。
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3">
              <button
                type="button"
                onClick={() => jump("access")}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-foreground-950 text-sm md:text-base font-label font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-route-line" />
                回到访问流程
              </button>
              <button
                type="button"
                onClick={() => jump("faq")}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-primary-300 text-background-50 text-sm md:text-base font-label font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-question-answer-line" />
                查看问题速查
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}